export const TASK_STATUS = {
  PRE_CAD: 'pre_cad',
  CAD_IN_PROGRESS: 'cad_in_progress',
  CAD_COMPLETED: 'cad_completed',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  REVISION_REQUESTED: 'revision_requested',
};

export const STATUS_LABELS = {
  pre_cad: 'Pre-CAD',
  cad_in_progress: 'CAD in Progress',
  cad_completed: 'CAD Completed',
  accepted: 'Accepted',
  rejected: 'Rejected',
  revision_requested: 'Revision Requested',
  // Legacy mapping
  qc_review: 'CAD Completed',
  pending: 'Pre-CAD',
  assigned_to_head: 'Pre-CAD',
  issued: 'Pre-CAD',
  in_progress: 'CAD in Progress',
  on_hold: 'CAD in Progress',
  designer_submitted: 'CAD Completed',
  designer_qc_done: 'CAD Completed',
  design_head_approved: 'CAD Completed',
  sent_to_client: 'CAD Completed',
  sent_for_client_approval: 'CAD Completed',
  client_revision: 'Revision Requested',
  client_approved: 'Accepted',
  cad_head_approved: 'CAD Completed',
  approved: 'Accepted',
  completed: 'Accepted',
  sampling: 'Accepted',
};

export const STATUS_TRANSITIONS = {
  pre_cad: ['cad_in_progress'],
  cad_in_progress: ['cad_completed', 'pre_cad'],
  cad_completed: ['accepted', 'rejected', 'revision_requested', 'cad_in_progress'],
  accepted: ['revision_requested', 'rejected', 'cad_in_progress'],
  rejected: ['revision_requested', 'cad_in_progress'],
  revision_requested: ['cad_in_progress'],
  // Legacy → allow moving to new statuses
  pending: ['cad_in_progress'],
  in_progress: ['cad_completed'],
  on_hold: ['cad_in_progress'],
  sent_to_client: ['accepted', 'rejected', 'revision_requested'],
  approved: ['revision_requested'],
  completed: ['revision_requested'],
};

export const STATUS_COLORS = {
  pre_cad: 'bg-slate-50 text-slate-700 border-slate-200',
  cad_in_progress: 'bg-blue-50 text-blue-700 border-blue-200',
  cad_completed: 'bg-amber-50 text-amber-700 border-amber-200',
  accepted: 'bg-green-50 text-green-700 border-green-200',
  rejected: 'bg-red-50 text-red-700 border-red-200',
  revision_requested: 'bg-rose-50 text-rose-700 border-rose-200',
  // Legacy mapping
  qc_review: 'bg-amber-50 text-amber-700 border-amber-200',
  pending: 'bg-slate-50 text-slate-700 border-slate-200',
  assigned_to_head: 'bg-slate-50 text-slate-700 border-slate-200',
  issued: 'bg-slate-50 text-slate-700 border-slate-200',
  in_progress: 'bg-blue-50 text-blue-700 border-blue-200',
  on_hold: 'bg-blue-50 text-blue-700 border-blue-200',
  designer_submitted: 'bg-amber-50 text-amber-700 border-amber-200',
  designer_qc_done: 'bg-amber-50 text-amber-700 border-amber-200',
  design_head_approved: 'bg-amber-50 text-amber-700 border-amber-200',
  sent_to_client: 'bg-amber-50 text-amber-700 border-amber-200',
  sent_for_client_approval: 'bg-amber-50 text-amber-700 border-amber-200',
  client_revision: 'bg-rose-50 text-rose-700 border-rose-200',
  client_approved: 'bg-green-50 text-green-700 border-green-200',
  completed: 'bg-green-50 text-green-700 border-green-200',
  sampling: 'bg-green-50 text-green-700 border-green-200',
  cad_head_approved: 'bg-amber-50 text-amber-700 border-amber-200',
};

// Full-row background colors for All Tasks grid
export const STATUS_ROW_COLORS = {
  pre_cad: 'bg-slate-50/70',
  cad_in_progress: 'bg-blue-50/70',
  cad_completed: 'bg-amber-50/70',
  accepted: 'bg-green-100/70',
  rejected: 'bg-red-100/70',
  revision_requested: 'bg-red-100/70',
  // Legacy
  pending: 'bg-slate-50/70',
  assigned_to_head: 'bg-slate-50/70',
  issued: 'bg-slate-50/70',
  in_progress: 'bg-blue-50/70',
  on_hold: 'bg-blue-50/70',
  qc_review: 'bg-amber-50/70',
  sent_to_client: 'bg-amber-50/70',
  approved: 'bg-green-100/70',
  completed: 'bg-green-100/70',
  sampling: 'bg-green-100/70',
  client_approved: 'bg-green-100/70',
  client_revision: 'bg-red-100/70',
};

export const PRIORITY_LEVELS = [
  { value: 'normal', label: 'Normal' },
  { value: 'super_rush', label: 'SUPER RUSH' },
];

export const CAD_DIFFICULTY_LEVELS = [
  { value: 'simple', label: 'Simple', multiplier: 0.5 },
  { value: 'moderate', label: 'Moderate', multiplier: 1.0 },
  { value: 'complex', label: 'Complex', multiplier: 1.8 },
  { value: 'expert', label: 'Expert', multiplier: 3.0 },
];

export const PIECE_TYPES = [
  { value: 'ring', label: 'Ring' },
  { value: 'earring', label: 'Earring' },
  { value: 'pendant', label: 'Pendant' },
  { value: 'necklace', label: 'Necklace' },
  { value: 'bracelet', label: 'Bracelet' },
  { value: 'bangle', label: 'Bangle' },
  { value: 'others', label: 'Others' }
];

export const METAL_TYPES = [
  { value: 'gold', label: 'Gold' },
  { value: 'silver', label: 'Silver' },
  { value: 'platinum', label: 'Platinum' },
  { value: 'brass', label: 'Brass' }
];

export const METAL_COLOURS = {
  gold: ['Yellow', 'White', 'Rose', 'Green'],
  silver: ['White', 'Oxidized'],
  platinum: ['White'],
  brass: ['Yellow', 'Antique']
};

export const METAL_KARATS = {
  gold: ['24K', '22K', '18K', '14K', '10K', '9K'],
  silver: ['S925', '950', '999'],
  platinum: ['950', '900'],
  brass: ['N/A']
};

// Findings/Components by piece type
export const FINDINGS_BY_PIECE_TYPE = {
  ring: [
    { name: 'None', code: 'NONE' }
  ],
  earring: [
    { name: 'None', code: 'NONE' },
    { name: 'Post/Double Groove 0.80 x 13.70', code: 'POST_0.80_13.70', weights: { '9K': 0.10, '10K': 0.11, '14K': 0.12, '18K': 0.13, 'S925': 0.09 } },
    { name: 'Post/Double Groove 0.80 x 11.70', code: 'POST_0.80_11.70', weights: { '9K': 0.09, '10K': 0.10, '14K': 0.11, '18K': 0.12, 'S925': 0.08 } },
    { name: 'Post/Double Groove 0.90 x 13.70', code: 'POST_0.90_13.70', weights: { '9K': 0.12, '10K': 0.13, '14K': 0.14, '18K': 0.15, 'S925': 0.11 } },
    { name: 'Post/Double Groove 0.90 x 11.70', code: 'POST_0.90_11.70', weights: { '9K': 0.11, '10K': 0.12, '14K': 0.13, '18K': 0.14, 'S925': 0.10 } },
    { name: 'BF4022 5.5MM Butterfly', code: 'BF4022_5.5MM', weights: { '9K': 0.27, '10K': 0.30, '14K': 0.35, '18K': 0.40, 'S925': 0.30 } },
    { name: 'BF4023 7.00MM Butterfly', code: 'BF4023_7.00MM', weights: { '9K': 0.36, '10K': 0.40, '14K': 0.45, '18K': 0.50, 'S925': 0.35 } },
    { name: 'BF4024 8.00MM Butterfly', code: 'BF4024_8.00MM', weights: { '9K': 0.41, '10K': 0.45, '14K': 0.50, '18K': 0.58, 'S925': 0.41 } },
    { name: 'BF4025 9.00MM Butterfly', code: 'BF4025_9.00MM', weights: { '9K': 0.45, '10K': 0.50, '14K': 0.57, '18K': 0.68, 'S925': 0.50 } },
    { name: 'Fish Lock 9MM/8.2MM', code: 'FISH_LOCK_9MM', weights: { '9K': 0.32, '10K': 0.35, '14K': 0.40, '18K': 0.45, 'S925': 0.30 } }
  ],
  pendant: [
    { name: 'None', code: 'NONE' },
    { name: 'Bail Small', code: 'BAIL_S', weights: { '9K': 0.14, '10K': 0.15, '14K': 0.18, '18K': 0.20, 'S925': 0.12 } },
    { name: 'Bail Medium', code: 'BAIL_M', weights: { '9K': 0.23, '10K': 0.25, '14K': 0.30, '18K': 0.35, 'S925': 0.20 } },
    { name: 'Bail Large', code: 'BAIL_L', weights: { '9K': 0.32, '10K': 0.35, '14K': 0.40, '18K': 0.45, 'S925': 0.30 } }
  ],
  necklace: [
    { name: 'None', code: 'NONE' },
    { name: 'Spring Ring Clasp', code: 'SPRING_RING', weights: { '9K': 0.36, '10K': 0.40, '14K': 0.45, '18K': 0.50, 'S925': 0.35 } },
    { name: 'Lobster Clasp Small', code: 'LOBSTER_S', weights: { '9K': 0.45, '10K': 0.50, '14K': 0.55, '18K': 0.63, 'S925': 0.45 } },
    { name: 'Lobster Clasp Large', code: 'LOBSTER_L', weights: { '9K': 0.56, '10K': 0.62, '14K': 0.72, '18K': 0.80, 'S925': 0.55 } }
  ],
  bracelet: [
    { name: 'None', code: 'NONE' },
    { name: 'Fish Lock 9MM/8.2MM', code: 'FISH_LOCK_9MM', weights: { '9K': 0.32, '10K': 0.35, '14K': 0.40, '18K': 0.45, 'S925': 0.30 } },
    { name: 'Box Clasp', code: 'BOX_CLASP', weights: { '9K': 0.50, '10K': 0.55, '14K': 0.63, '18K': 0.72, 'S925': 0.48 } },
    { name: 'Toggle Clasp', code: 'TOGGLE', weights: { '9K': 0.59, '10K': 0.65, '14K': 0.75, '18K': 0.85, 'S925': 0.55 } }
  ],
  bangle: [
    { name: 'None', code: 'NONE' },
    { name: 'Box Clasp', code: 'BOX_CLASP', weights: { '9K': 0.50, '10K': 0.55, '14K': 0.63, '18K': 0.72, 'S925': 0.48 } },
    { name: 'Hinge Clasp', code: 'HINGE', weights: { '9K': 0.63, '10K': 0.70, '14K': 0.80, '18K': 0.90, 'S925': 0.60 } }
  ],
  others: [
    { name: 'None', code: 'NONE' }
  ]
};

export const DIAMOND_TYPES = [
  { value: 'natural', label: 'Natural' },
  { value: 'lab_grown', label: 'Lab Grown' }
];

export const STONE_SHAPES = [
  'Round', 'Princess', 'Emerald', 'Oval', 'Pear', 'Cushion', 'Marquise', 'Radiant', 'Asscher', 'Heart'
];

export const DIAMOND_COLOURS = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
export const DIAMOND_CLARITY = ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'I1'];
export const DIAMOND_CUTS = ['Excellent', 'Very Good', 'Good', 'Fair', 'Poor'];
export const SETTING_TYPES = ['Prong', 'Micro Pave', 'Channel', 'Bezel', 'Invisible', 'Tension'];

// Stone identity / ownership / position category — shared between Task form and CAD sheet
export const STONE_TYPES = ['Natural', 'Lab', 'CVD', 'Colour Stone'];
export const STONE_OWNERSHIPS = ['KS Goods', 'Party Goods'];
export const STONE_POSITION_CATEGORIES = ['Center Stone', 'Accent Stone', 'Side Stone'];

// Finishing options — shared between Task form and CAD sheet (single source of truth)
export const FINISHING_TYPES = ['High Polish', 'Matte', 'Satin', 'Brushed', 'Hammered', 'Sandblasted', 'Other'];

export const STAGES = [
  { value: 'idea', label: 'Idea/Sketch' },
  { value: 'cad_in_progress', label: 'CAD In Progress' },
  { value: 'cad_approved', label: 'CAD Approved' },
  { value: 'sampling', label: 'Sampling' },
  { value: 'final_approval', label: 'Final Approval' },
  { value: 'moved_to_order', label: 'Moved to Order' }
];

export const GENDER_OPTIONS = [
  { value: 'men', label: 'Men' },
  { value: 'women', label: 'Women' },
  { value: 'unisex', label: 'Unisex' }
];

export const QUOTATION_TYPES = [
  { value: 'pd', label: 'PD Based' },
  { value: 'po', label: 'PO Based' }
];

export const CAD_FORMATS = [
  { value: '3dm', label: '3DM (Rhino)' },
  { value: 'stl', label: 'STL' },
  { value: 'obj', label: 'OBJ' },
  { value: 'step', label: 'STEP' }
];

// Simplified roles: Executor (full access), Admin (executor + audit/users), Customer
export const USER_ROLE = {
  ADMIN: 'admin',
  EXECUTOR: 'executor',
  SPECIAL_EXECUTOR: 'special_executor',
  FINAL_EXECUTOR: 'final_executor',
  CUSTOMER: 'customer',
  // Legacy mappings
  MASTER_ADMIN: 'admin',
  SALES: 'executor',
  CAD_HEAD: 'executor',
  DESIGN_HEAD: 'executor',
  DESIGNER: 'executor',
};

export const USER_ROLE_LABELS = {
  admin: 'Admin',
  executor: 'Executor',
  special_executor: 'Special Executor',
  final_executor: 'Final Executor',
  customer: 'Customer',
  stone_supplier: 'Stone Supplier',
  // Legacy labels
  master_admin: 'Admin',
  sales: 'Executor',
  cad_head: 'Executor',
  design_head: 'Executor',
  designer: 'Executor',
};

export const USER_STATUS = {
  PENDING_APPROVAL: 'pending_approval',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  SUSPENDED: 'suspended'
};

export const DEADLINE_FILTERS = [
  { value: 'overdue', label: 'Overdue', color: 'text-red-600' },
  { value: 'today', label: 'Due Today', color: 'text-orange-600' },
  { value: 'this_week', label: 'This Week', color: 'text-amber-600' },
  { value: 'this_month', label: 'This Month', color: 'text-blue-600' }
];


export const DESIGNERS = [
  { name: 'SUPRABHAT', hashtag: '#SUP' },
  { name: 'VIRAJ', hashtag: '#VIR' },
  { name: 'RUPAM', hashtag: '#RUP' },
  { name: 'GIRIJA', hashtag: '#GIR' },
  { name: 'SAHIL', hashtag: '#SAH' },
  { name: 'TANVI', hashtag: '#TAN' },
  { name: 'POOJA', hashtag: '#POO' },
  { name: 'SUROJIT', hashtag: '#SUR' },
  { name: 'DEBKUMAR', hashtag: '#DEB' },
  { name: 'DINBANDHU', hashtag: '#DIN' },
  { name: 'DIVYA', hashtag: '#DIV' },
  { name: 'PRITI', hashtag: '#PRI' },
  { name: 'DHARAM', hashtag: '#DHA' },
  { name: 'SAMIR', hashtag: '#SAM' },
  { name: 'NEHA', hashtag: '#NEH' },
  { name: 'GANESH', hashtag: '#GAN' },
  { name: 'KIRTI', hashtag: '#KIR' },
  { name: 'KRISHNA', hashtag: '#KRI' },
  { name: 'SUMIT', hashtag: '#SUM' },
  { name: 'SUSHANT', hashtag: '#SUS' },
  { name: 'TAPAS', hashtag: '#TAP' },
  { name: 'ARIYAN', hashtag: '#ARI' },
  { name: 'TRUPTI', hashtag: '#TRU' },
  { name: 'RAHUL', hashtag: '#RAH' },
  { name: 'JIAUR', hashtag: '#JIA' },
  { name: 'SANGEETA', hashtag: '#SAN' },
  { name: 'HARSHAD', hashtag: '#HAR' },
  { name: 'MASIUR', hashtag: '#MAS' },
  { name: 'JAYANTO', hashtag: '#JAY' },
  { name: 'TANMAY', hashtag: '#TNM' },
  { name: 'MEENAKSHI', hashtag: '#MEE' },
  { name: 'NIKHIL', hashtag: '#NIK' },
  { name: 'SUBHRO', hashtag: '#SUB' },
  { name: 'SOUMYADEEP', hashtag: '#SOU' },
  { name: 'REHMAN', hashtag: '#REH' },
  { name: 'JAYESH', hashtag: '#JYS' },
];

// ===== Stone Procurement (RFQ portal) =====

export const STONE_KINDS = [
  { value: 'lab', label: 'Lab Grown' },
  { value: 'natural', label: 'Natural' },
  { value: 'coloured', label: 'Coloured Stone' },
  { value: 'cz', label: 'CZ / Simulant' },
  { value: 'other', label: 'Other (specify)' },
];

// Common gemstones organized by family. Used to populate the "Stone Type" dropdown
// on stone requirements. Suppliers see the same list for clarity.
export const GEMSTONE_TYPES = [
  // Precious
  'Diamond', 'Ruby', 'Sapphire', 'Emerald',
  // Quartz
  'Amethyst', 'Citrine', 'Rose Quartz', 'Smoky Quartz', 'Lemon Quartz', 'Ametrine',
  // Beryl
  'Aquamarine', 'Morganite', 'Heliodor',
  // Tourmaline
  'Pink Tourmaline', 'Green Tourmaline', 'Paraiba Tourmaline', 'Watermelon Tourmaline',
  // Garnet
  'Garnet', 'Tsavorite', 'Rhodolite', 'Spessartite Garnet',
  // Feldspar / Moonstone
  'Moonstone', 'Labradorite', 'Sunstone',
  // Other popular
  'Peridot', 'Topaz', 'Tanzanite', 'Opal', 'Turquoise', 'Spinel', 'Zircon',
  'Iolite', 'Kunzite', 'Apatite', 'Jade', 'Onyx', 'Lapis Lazuli', 'Malachite',
  'Coral', 'Pearl', 'Bloodstone', 'Chalcedony', 'Carnelian', 'Agate',
  'Amazonite', 'Fluorite',
];

export const STONE_REQUIREMENT_STATUSES = [
  { value: 'open', label: 'Open', color: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  { value: 'closed', label: 'Closed (Awarded)', color: 'bg-blue-50 text-blue-700 border-blue-200' },
  { value: 'cancelled', label: 'Cancelled', color: 'bg-slate-100 text-slate-600 border-slate-200' },
];

// Certificate types — used on requirement (admin specifies what they want)
// and on quote (supplier specifies what they provide).
export const CERTIFICATE_TYPES = [
  { value: 'none', label: 'No certificate' },
  { value: 'igi', label: 'IGI' },
  { value: 'gia', label: 'GIA' },
  { value: 'any', label: 'Any (IGI or GIA)' },
  { value: 'other', label: 'Other' },
];

export const CERTIFICATE_TYPES_QUOTE = [
  { value: 'none', label: 'No certificate' },
  { value: 'igi', label: 'IGI' },
  { value: 'gia', label: 'GIA' },
  { value: 'other', label: 'Other' },
];

export const STONE_QUOTE_STATUSES = {
  submitted: { label: 'Submitted', color: 'bg-amber-50 text-amber-700 border-amber-200' },
  revise_requested: { label: 'Revise Requested', color: 'bg-violet-50 text-violet-700 border-violet-200' },
  accepted: { label: 'Accepted', color: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  rejected: { label: 'Rejected', color: 'bg-rose-50 text-rose-700 border-rose-200' },
};
